/**
 * InstructionEntry — a written instruction / message to the client.
 * data: { body: markdown string }
 * Client action: acknowledge ("I've read this").
 */

import Markdown from '../../components/Markdown.jsx'
import { J, PrimaryButton, DoneChip, ViewOnlyNote } from '../journeyUI.jsx'

export default function InstructionEntry({ entry, response, onRespond, viewOnly }) {
  const acknowledged = response && response.kind === 'acknowledge'
  return (
    <div>
      <div style={J.eyebrow}>Instructions</div>
      {entry.title && <h2 style={J.title}>{entry.title}</h2>}
      <hr style={J.rule} />
      <div style={J.body}>
        <Markdown text={entry.data?.body || ''} />
      </div>
      <div style={{ marginTop: 28 }}>
        {acknowledged
          ? <DoneChip>Acknowledged</DoneChip>
          : viewOnly ? <ViewOnlyNote>The owner acknowledges this one.</ViewOnlyNote>
          : <PrimaryButton onClick={() => onRespond('acknowledge')}>Acknowledge</PrimaryButton>}
      </div>
    </div>
  )
}
